<template>
  <b-table
    :id="`annual-cost-table`"
    bordered
    :ref="`annual-cost-table`"
    head-variant="light"
    :fields="fields"
    :items="getAnnualBudgetItems(budgetYear)"
    :tbody-tr-class="rowClass"
    class="list-item-small-table"
    show-empty>
  </b-table>
</template>
<script>
import ProjectTotalsCalculator from '@/mixins/projectTotalsCalculator';

export default {
  props: {
    budgetYear: Object,
  },
  mixins: [
    ProjectTotalsCalculator,
  ],
  data() {
    return {
      fields: [
        {
          key: 'Costs',
          label: 'Costs',
          class: 'cost-text-column',
        },
        {
          key: 'Base_Cost',
          label: 'Base Cost',
          formatter: (value) => {
            if (!value) {
              return this.$options.filters.toCurrency(0.0);
            }
            return this.$options.filters.toCurrency(value);
          },
          class: 'text-right currency-column',
        },
        {
          key: 'Contingency',
          label: 'Contingency',
          formatter: (value) => {
            if (!value) {
              return this.$options.filters.toCurrency(0.0);
            }
            return this.$options.filters.toCurrency(value);
          },
          class: 'text-right currency-column',
        },
        {
          key: 'Total',
          label: 'Total',
          formatter: (value) => {
            if (!value) {
              return this.$options.filters.toCurrency(0.0);
            }
            return this.$options.filters.toCurrency(value);
          },
          class: 'text-right currency-column',
        },
      ],
    };
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== 'row') return '';
      if (item.Costs === 'Annual Cost') return 'font-weight-bold with-top-border';
      return '';
    },
  },
};
</script>
